import React from 'react';
import { Text } from '@pixi/react';
import { gameStateManager } from '../../App';

const PixiScaledText = ( { x, y, text, style, stageRenderData, ...props } ) =>
{
  const stageHeight = stageRenderData.height;
  const renderScale = stageRenderData.scale;
  const stageHeightRef = gameStateManager.canvasRefHeight;

  return (

    <Text
      text={ text }
      x={ x }
      y={ ( y / stageHeightRef ) * stageHeight }
      anchor={ ( props.anchor ? props.anchor : 0 ) }
      style={ {
        ...style,
        fontSize: ( props.fontSize ?? 20 ) * renderScale,
        fontWeight: props.fontWeight ?? "normal"
      } }
    />
  );
}

export default PixiScaledText;
